<div class="flex flex-col min-h-screen w-full">
  <div class="flex-1 overflow-y-auto">
    <router-outlet />
  </div>
  <div class="flex-shrink-0 text-center py-4 text-secondary-text text-xs">
    v{{ appVersion }}
  </div>
</div>
